// src/components/Tablo.jsx
import React, { useEffect, useState } from "react";
import SwitchButton from "../components/SwitchButton";
import EditableText from "../components/EditableText";
import { toast } from "react-toastify";
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

function Tablo() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [itemStates, setItemStates] = useState({});
  
  // ================= دریافت داده‌ها =================
  const fetchCategories = async () => {
    try {
      const res = await fetch(apiUrl("/api/categories"));
      const data = await res.json();
      setCategories(data);
      
      const initialStates = {};
      data.forEach(cat => {
        cat.items.forEach(item => {
          initialStates[item.id] = {
            switch1: item.trade ?? false,
            switch2: item.buy ?? false,
            switch3: item.sell ?? false,
          };
        });
      });
      setItemStates(initialStates);
      
      if (data.length && !selectedCategory) {
        setSelectedCategory(data[0].id);
      }
    } catch (e) {
      toast.error("خطا در دریافت سربرگ‌ها");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // ================= ارسال Real-time به بک =================
  const syncToServer = async (itemId, switches) => {
    try {
      const res = await fetch(
        apiUrl("/api/category/item/switch"),
        {
          method: "POST",
          headers: adminAuthHeaders({ "Content-Type": "application/json" }),
          body: JSON.stringify({
            itemId,
            switches: {
              trade: switches.switch1 || false,
              buy: switches.switch2 || false,
              sell: switches.switch3 || false,
            },
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        toast.error(data.error || "خطا در ذخیره تغییرات وضعیت");
      }
    } catch (e) {
      toast.error("خطای ارتباط با سرور");
    }
  };

  // ================= آپدیت فی خرید/فروش =================
  const updateItemValue = async (itemId, values) => {
    try {
      const res = await fetch(
        apiUrl(`/api/item/${itemId}/value`),
        {
          method: "PUT",
          headers: adminAuthHeaders({ "Content-Type": "application/json" }),
          body: JSON.stringify(values),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        toast.error(data.error || "خطا در ذخیره مقدار");
      }
    } catch (e) {
      toast.error("خطای ارتباط با سرور");
    }
  };

  const adjustItemValue = async (itemId, field, currentValue, amount) => {
    const baseValue = Number(currentValue || 0);
    const nextValue = Math.max(0, baseValue + amount);

    setCategories((prev) =>
      prev.map((category) => ({
        ...category,
        items: category.items.map((item) =>
          item.id === itemId
            ? { ...item, [field]: String(nextValue) }
            : item
        ),
      }))
    );

    await updateItemValue(itemId, { [field]: String(nextValue) });
  };

  // ================= تغییر سوییچ =================
  const handleSwitchChange = (itemId, name, value) => {
    setItemStates((prev) => {
      const updatedItem = { ...(prev[itemId] || {}), [name]: value };
      syncToServer(itemId, updatedItem);
      return { ...prev, [itemId]: updatedItem };
    });
  };

  const activeCategory = categories.find((c) => c.id === selectedCategory);

  return (
    <div>
      <div className="SelectedHeader">
        شما در این قسمت می توانید مظنه تابلو خود را به صورت دستی تغییر دهید
      </div>
      
      <div className="SarbargNav" style={{ marginTop: "15px" }}>
        {categories.map((cat) => (
          <div
            key={cat.id}
            onClick={() => setSelectedCategory(cat.id)}
            style={{ cursor: "pointer" }}
            className={selectedCategory === cat.id ? "BgYellow ColorBlack Bold" : ""}
          >
            {cat.name}
          </div>
        ))}
      </div>
      
      <div className="TabloNav">
        <p>وضعیت</p>
        <p>جنس</p>
        <p>وضعیت معاملات</p>
        <p>فی فروش</p>
        <p>وضعیت معاملات</p>
        <p>فی خرید</p>
      </div>
      
      {activeCategory?.items?.map((item) => {
        const current = itemStates[item.id] || {
          switch1: false,
          switch2: false,
          switch3: false,
        };
        
        // محاسبه نرخ هر گرم طلا بر اساس فی خرید یا فروش
        // فرمول: فی / 4.6082 = نرخ هر گرم طلا
        let goldPricePerGram = 0;
        if (current.switch2 && item.valueBuy) {
          goldPricePerGram = parseFloat(item.valueBuy) / 4.6082;
        } else if (current.switch3 && item.valueSell) {
          goldPricePerGram = parseFloat(item.valueSell) / 4.6082;
        }

        return (
          <div className="LinerTablo" key={item.id}>
            
            {/* ================= 1. وضعیت جنس (Switch 1) ================= */}
            <div className="TabloItem">
              <SwitchButton
                onChange={(v) => handleSwitchChange(item.id, "switch1", v)}
                defaultState={current.switch1}
              />
            </div>
            <div className="TabloItem">
              <EditableText
                initialText={item.title}
                isEnabled={current.switch1}
                onSave={(newTitle) => console.log("Title updated:", newTitle)} 
              />
            </div>
            
            {/* ================= 2. فی خرید (Switch 2) ================= */}
            <div className="TabloItem">
              <SwitchButton
                onChange={(v) => handleSwitchChange(item.id, "switch2", v)}
                defaultState={current.switch2}
              />
            </div>
            <div>
              <div className="TabloItem">
                <div className="PriceEditorGroup">
                  <div className="PriceAdjustColumn">
                    <button
                      type="button"
                      className="PriceAdjustBtn"
                      disabled={!current.switch2}
                      onClick={() => adjustItemValue(item.id, "valueBuy", item.valueBuy, 50000)}
                    >
                      +50000
                    </button>
                    <button
                      type="button"
                      className="PriceAdjustBtn"
                      disabled={!current.switch2}
                      onClick={() => adjustItemValue(item.id, "valueBuy", item.valueBuy, -50000)}
                    >
                      -50000
                    </button>
                  </div>
                  <EditableText
                    initialText={item.valueBuy || "0"}
                    isEnabled={current.switch2}
                    onSave={(newValue) => updateItemValue(item.id, { valueBuy: newValue })}
                  />
                </div>
              </div>
              <p className="PerGramFi">
                نرخ هر گرم :
                <span>
                  {goldPricePerGram > 0 ? goldPricePerGram.toFixed(0) : '-'}
                </span>
              </p>
            </div>

            {/* ================= 3. فی فروش (Switch 3) ================= */}
            <div className="TabloItem">
              <SwitchButton
                onChange={(v) => handleSwitchChange(item.id, "switch3", v)}
                defaultState={current.switch3}
              />
            </div>
            <div>
              <div className="TabloItem">
                <div className="PriceEditorGroup">
                  <div className="PriceAdjustColumn">
                    <button
                      type="button"
                      className="PriceAdjustBtn"
                      disabled={!current.switch3}
                      onClick={() => adjustItemValue(item.id, "valueSell", item.valueSell, 50000)}
                    >
                      +50000
                    </button>
                    <button
                      type="button"
                      className="PriceAdjustBtn"
                      disabled={!current.switch3}
                      onClick={() => adjustItemValue(item.id, "valueSell", item.valueSell, -50000)}
                    >
                      -50000
                    </button>
                  </div>
                  <EditableText
                    initialText={item.valueSell || "0"}
                    isEnabled={current.switch3}
                    onSave={(newValue) => updateItemValue(item.id, { valueSell: newValue })}
                  />
                </div>
              </div>
              <p className="PerGramFi">
                نرخ هر گرم :
                <span>
                  {goldPricePerGram > 0 ? goldPricePerGram.toFixed(0) : '-'}
                </span>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Tablo;
